// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchButton_switch__6qMJp","slider":"SwitchButton_slider__3RciR","round":"SwitchButton_round__2iUj7","label":"SwitchButton_label__2AIpz"};